import { h, Component } from 'preact';
import request from "../utils/Request";
import { observer } from "mobx-preact";
import { WINPAGE_DELAY } from "../constants/Common";
import { setCookie } from "../utils/Cookie";
import { SHOP } from "../constants/Common";
import { firstGate } from "./NonAnon";
import PhoneInput from "react-phone-input-2";

@observer
class FormV2 extends Component {
    constructor(props) {
        super(props);

        this.formStore = props.formStore;
        this.campaignStore = props.campaignStore;
        this.appStore = props.appStore;
        this.winPageStore = props.winPageStore;
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = { isUiOpenedClass: '' };
    }

    componentDidMount() {
        this.campaignStore.setPopUpColors(this.popUp);
        document.addEventListener('click', this.handleClickOutside, true);
        setCookie('_kol_saw_pop_up', true, 999);
        setTimeout(() => {
            this.setState({ isUiOpenedClass: 'kol-submit-form--ui-open' });
        }, "10");
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
        this.setState({ isUiOpenedClass: '' });
    }

    handleClickOutside = event => {
        if (!this.popUp.contains(event.target)) {
            this.appStore.hidePopUp()
        }
    }

    spin(spinDegrees) {
        document.removeEventListener('click', this.handleClickOutside, true);
        const wheelDynamic = document.querySelector('#wheel-dynamic');
        document.querySelector('#kol-popup').style.setProperty("--wheel-dynamic-rotate-deg", spinDegrees + "deg");
        wheelDynamic.classList.add('kol-rotating');
    }

    handleGDPRCheckboxChange = event => {
        this.formStore.GDPRCheckBoxError = false;
        this.formStore.GDPRCheckBoxChecked = !this.formStore.GDPRCheckBoxChecked;
    };

    get formData() {
        const { email, phoneNumber } = this.formStore;
        const { campaign_id } = this.campaignStore;
        return {
            email: email,
            phone_number: phoneNumber,
            campaign: campaign_id,
        }
    }

    showWinPage = () => {
        setTimeout(() => {
            this.appStore.hidePopUp();
            this.appStore.showWinPage = true;
        }, WINPAGE_DELAY);

    };

    handleEmailChange = event => {
        this.formStore.email = event.target.value;
        this.formStore.emailError = null;
    };

     handlePhoneChange = phone => {
        this.formStore.phoneNumber = phone;
        this.formStore.phoneNumberError = null;
    };


    getSpinDegreesByOptionId(optionId) {
        const { campaignOptions } = this.campaignStore;
        const sectorIndex = campaignOptions.findIndex(item => item.id === optionId);
        return 360 * 3 + ((8 - (sectorIndex)) * 360 / 8 - 22.5);
    }

    handleSubmit(event) {
        event.preventDefault();
        const {
            GDPRComplianceIsActive,
            addCheckboxToGDPRCompliance,
        } = this.campaignStore;
        if (GDPRComplianceIsActive && addCheckboxToGDPRCompliance && !this.formStore.GDPRCheckBoxChecked) {
            this.formStore.GDPRCheckBoxError = true;
            return
        }
        this.formStore.disableSubmit = true;
        const hName = 'X' + 'T' + 'O' + 'KEN'
        const header = firstGate(`${this.formData.email || this.formData.phone_number}${SHOP}`)
        request.post('/games/', {...this.formData, [hName]: header}).then(response => {
            this.winPageStore.getDataFromJson(response.data);
            const optionId = response.data.option_id;
            const spinDegrees = this.getSpinDegreesByOptionId(optionId);
            this.spin(spinDegrees);
        }).catch(
            e => {
                if (e.response.data['email']){
                    this.formStore.emailError = e.response.data['email'][0];
                }
                if (e.response.data['phone_number']){
                    this.formStore.phoneNumberError = e.response.data['phone_number'][0];
                }
                this.formStore.disableSubmit = false;
            }
        );
    }

    getFormInputs = () => {
        const {
            formEmailPlaceholder,
            GDPRComplianceIsActive,
            addCheckboxToGDPRCompliance,
            GDPRComplianceText,
            isPhoneNumberCampaign,
        } = this.campaignStore;
        const { email, phoneNumber, disableSubmit, emailError, phoneNumberError } = this.formStore;
        const formInputClass = emailError ? 'kol-popup__input__error' : 'kol-popup__input';
        const indianShops = ['kuvar-jewels-india.myshopify.com', 'gulabojaipur.myshopify.com'];
        const country = indianShops.includes(SHOP) ? 'in' : 'us';
        return <div className="kol-popup__form">
            {isPhoneNumberCampaign ? <PhoneInput
                    country={country}
                    containerClass="kol-input--phone-number"
                    value={phoneNumber}
                    onChange={this.handlePhoneChange}
                    style="high-res"
                /> :
                <input className={formInputClass} type="email"
                       placeholder={formEmailPlaceholder}
                       name="email" value={email} onChange={this.handleEmailChange}/>}

            {emailError ? <span className="kol-email__error">{emailError}</span> : null}
            {phoneNumberError ? <span className="kol-email__error">{phoneNumberError}</span> : null}

            <input className="kol-button kol-popup__submit" type="submit"
                onClick={this.handleSubmit}
                disabled={disableSubmit ? 'disabled' : ''}
                value={this.campaignStore.spinButtonText} />
            {GDPRComplianceIsActive ?
            <div class="kol-popup__gdpr kol-popup__gdpr--v2">
                {addCheckboxToGDPRCompliance ?
                <label class={
                    `kol-checkbox-container kol-popup__gdpr-checkbox ${this.formStore.GDPRCheckBoxError ? 'kol-checkbox-container--error': ''}`
                }>
                    <input type='checkbox' onChange={this.handleGDPRCheckboxChange}/>
                    <span class="kol-checkbox-checkmark"></span>
                </label>: null}
                <p class="kol-text-line-narrow kol-popup__gdpr-text" dangerouslySetInnerHTML={{__html: GDPRComplianceText}}>
                </p>
            </div>: null}
        </div>
    };
    getSectorClassName = (campaignOption) => {

        const sectorLen = campaignOption.length;
        let textSize = 'm'
        if (sectorLen > 19) {
            textSize = 'xs'
        }
        else if (sectorLen > 15) {
            textSize = 's'
        }
        return `kol-popup__sector-text kol-popup__sector-text--${textSize}`
    }

    render() {
        const { campaignOptions, formHeading } = this.campaignStore;
        const sectorClassName = `kol-popup__sector-text kol-popup__sector-text--m`;
        return <form id="kol-popup" className={`kol-contrast-calc kol-submit-form kol-submit-form--theme-light ${this.state.isUiOpenedClass}`} onSubmit={this.handleSubmit}
            ref={popUp => this.popUp = popUp}>
            <div className="kol-popup__wheel" id="kol-wheel">
                <svg class="kol-popup__wheel-pointer kol-box-shadow" xmlns="http://www.w3.org/2000/svg" width="26" height="40" viewBox="0 0 26 40">
                    <path d="M13.054 0c-.037 0-.07.005-.108.005-.035 0-.07-.005-.106-.005A12.92 12.92 0 0 0 0 13c0 5.484 6.651 20.279 12.946 27C19.294 33.279 26 18.484 26 13A12.973 12.973 0 0 0 13.054 0z"
                        fill="#fff" />
                    <circle cx="13" cy="13" r="9" fill="var(--kol-circle-main-color)" />
                </svg>
                <div id="wheel-dynamic" className="kol-popup__wheel-wrapper" onAnimationEnd={this.showWinPage}>
                    <div className="kol-popup__sectors-text" style={{ color: "var(--kol-sector-text-color)" }}>
                        <span className={this.getSectorClassName(campaignOptions[0].label)}>{campaignOptions[0].label}</span>
                        <span className={this.getSectorClassName(campaignOptions[1].label)}>{campaignOptions[1].label}</span>
                        <span className={this.getSectorClassName(campaignOptions[2].label)}>{campaignOptions[2].label}</span>
                        <span className={this.getSectorClassName(campaignOptions[3].label)}>{campaignOptions[3].label}</span>
                        <span className={this.getSectorClassName(campaignOptions[4].label)}>{campaignOptions[4].label}</span>
                        <span className={this.getSectorClassName(campaignOptions[5].label)}>{campaignOptions[5].label}</span>
                        <span className={this.getSectorClassName(campaignOptions[6].label)}>{campaignOptions[6].label}</span>
                        <span className={this.getSectorClassName(campaignOptions[7].label)}>{campaignOptions[7].label}</span>
                    </div>
                    <svg className="kol-popup__wheel-svg" width="310" height="310" viewBox="0 0 310 310">
                        <circle cx="155" cy="155" r="150" fill="var(--kol-circle-main-color)" />
                        <g className="wheel__text"
                            style="transform-origin: 50% 50%; transform-box: fill-box;">
                            <path data-sector="2" fill="var(--kol-sector-text-color)"
                                d="M48.934 48.934A149.39 149.39 0 0 0 5 154.934h150z" opacity=".09" />
                            <path data-sector="4" fill="var(--kol-sector-text-color)"
                                d="M48.967 261.066a149.39 149.39 0 0 0 106 43.934V155z" opacity=".14" />
                            <path data-sector="6" fill="var(--kol-sector-text-color)"
                                d="M261.066 261A149.39 149.39 0 0 0 305 155H155z" opacity=".09" />
                            <path data-sector="8" fill="var(--kol-sector-text-color)"
                                d="M261.033 48.934A149.39 149.39 0 0 0 155.033 5v150z" opacity=".14" />
                        </g>
                        <circle class="kol-box-shadow" cx="155" cy="155" r="10" fill="#fff" />
                        <path class="kol-box-shadow"
                            d="M154.683 310C69.217 309.825-.174 240.15 0 154.683.175 69.217 69.85-.174 155.317 0 240.784.175 310.174 69.85 310 155.317 309.825 240.784 240.15 310.174 154.683 310zm.613-300C75.343 9.837 10.164 74.75 10 154.704S74.75 299.836 154.704 300 299.836 235.25 300 155.296 235.25 10.164 155.296 10z"
                            fill="#fff" />
                    </svg>
                </div>
            </div>
            <div className="kol-popup__header">
                <h5 className="kol-popup__title mb-1em">
                    {formHeading}
                </h5>
                {this.getFormInputs()}
                <button className="kol-button kol-popup__close" onClick={this.appStore.hidePopUp}>
                    <svg width="16" height="16">
                        <path fill="white"
                            d="M15.35 14.65a.48.48 0 0 1 0 .7.48.48 0 0 1-.7 0L8 8.71l-6.65 6.64a.47.47 0 0 1-.35.15.47.47 0 0 1-.35-.15.48.48 0 0 1 0-.7L7.29 8 .65 1.35a.48.48 0 0 1 0-.7.48.48 0 0 1 .7 0L8 7.29 14.65.65a.48.48 0 0 1 .7 0 .48.48 0 0 1 0 .7L8.71 8z" />
                    </svg>
                </button>
            </div>
        </form>
    }
}

export default FormV2;
